<template>
  <div class="app-container">
    <el-form
      ref="params"
      :model="params"
      :inline="true"
      v-loading="loading"
    >
      <el-form-item>
        <el-input
          v-model="params.orderNumber"
          class="input"
          size="mini"
          style="width:150px"
          placeholder="请输入支付订单号"
          clearable
        />
      </el-form-item>
      
      <el-form-item>
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-search"
          @click="handQuery"
        >查询并校准</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { queryAndCheckUnionOrder} from '@/api/guarantee/finance'
export default {
  name: 'queryA',
  data() {
    return {
        loading:false,
      params: {
        orderNumber:undefined
      }
    }
  },
  created() {
  },
  methods: {
    // 获取选中的id
    async handQuery() {
        if(!this.params.orderNumber){
            return this.$msgError('订单号不能为空')
        }
       this.loading=true
       try {
         const res = await queryAndCheckUnionOrder(this.params)
            if (res.data.success) {
                this.$message.success('校准成功')
            } else {
                this.$msgError(res.data.message)
            }
       } catch (error) {
         this.loading=false
         this.$message.error('校准失败')
       } finally {
         this.loading=false
       }    
    }
  }
}
</script>

<style scoped lang="scss">
 .el-table .warning-row {
    /* background: #f35565; */
    border: 1px solid #f35565;
    /* color:#ffffff; */
  }

  .el-table .success-row {
    background: #ffffff;
  }
  .upload{
    color:red;
  }
  ::v-deep .el-form-item {
    display: inline-block;
    vertical-align: top;
    margin: 0 0 0 10px;
}
</style>